import _orderBy from 'lodash/orderBy';

export const state = {
  sortCurrentChildPinFolder: {
    loading: false,
    data: [],
  },
}


export const getters = {
}


export const mutations = {
  // SORTING PIN FOLDER
  sortByPinFolder: (state, data) => {
    let selectedItems = data.items;
    let order = data.order;
    let key = data.key;

    
    state.sortCurrentChildPinFolder.data = selectedItems;

    state.sortCurrentChildPinFolder.data = _orderBy(selectedItems, key, order.toLowerCase());
  }
}


export const actions = {
}